const resumeLink = "https://drive.google.com/file/d/1Be4i36zX0Fp2UjcGw6wBKXJ7vi6K3qrS/view?usp=sharing";
export default resumeLink;